// extracted by css-extract-rspack-plugin
export default {"list":"wzMajaR7fszOQByF"};